export default __webpack_public_path__ + "50628600daf508291684c830c2cf64a7.png";